import { type JSX } from 'react';

export const InfoIcon = (): JSX.Element => {
  return (
    <svg fill="none" height="11" viewBox="0 0 11 11" width="11" xmlns="http://www.w3.org/2000/svg">
      <circle cx="5.5" cy="5.5" r="5" stroke="#9D9DA3" />
      <path
        d="M5.32 7.68c-.378 0-.683.314-.683.691 0 .368.296.692.682.692.386 0 .692-.324.692-.692 0-.377-.315-.691-.692-.691zM5.436 2.444c-1.212 0-1.769.719-1.769 1.204 0 .35.296.511.539.511.485 0 .287-.691 1.203-.691.449 0 .808.198.808.61 0 .485-.503.764-.799 1.015-.26.225-.602.593-.602 1.365 0 .467.126.602.494.602.44 0 .53-.198.53-.368 0-.467.009-.737.503-1.123.242-.188 1.006-.799 1.006-1.643s-.764-1.482-1.913-1.482z"
        fill="#9D9DA3"
      />
    </svg>
  );
};
